import styled from '@emotion/styled';
import { Page } from 'react-pdf';

export const StyledPage: any = styled(Page)<{
	selected: boolean;
	width: number;
	style: React.CSSProperties;
}>(
	({ selected }) => `
	
	border-radius: 2px;
	margin-bottom: 10px;
	width: ${props => props.width}px;
	height: 100%;
	position: absolute;
	display: flex;
	justify-content: center;

	canvas {
		border: ${selected ? '2px solid #0045DB' : '1px solid #d9d9d9'};
		filter:  ${selected ? ' drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.24))' : 'none'};
		
	}`
);
